import { render, staticRenderFns } from "./ReplyNewPropertyDivision.vue?vue&type=template&id=6bf50b05"
import script from "./ReplyNewPropertyDivision.vue?vue&type=script&lang=ts"
export * from "./ReplyNewPropertyDivision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports